module.exports = __webpack_public_path__ + "static/img/solutionDetailPic21.b743194.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic21.jpg
// module id = hfcs
// module chunks = 1